import {Field, reduxForm} from 'redux-form'
import styles from './style.css'
import UploadImage from 'components/Fields/ReduxForm/UploadImage'
import SettingField from 'components/Fields/ReduxForm/SettingField'
import PhoneNumberField from 'components/Fields/ReduxForm/PhoneNumberField'
import gravatarDefault from 'assets/images/account-profile-default.jpg'

const validate = values => {
  const errors = {}
  const FIELD_REQUIRED_ERROR = 'This field is required'
  let {name, address, city, province, phone, email} = values
  if (!name) {
    errors.name = FIELD_REQUIRED_ERROR
  }
  if (!address) {
    errors.address = FIELD_REQUIRED_ERROR
  }
  if (!city) {
    errors.city = FIELD_REQUIRED_ERROR
  }
  if (!province) {
    errors.province = FIELD_REQUIRED_ERROR
  }
  if ((!values.postal_code) || (!/^\d{5}$/.test(values.postal_code))) {
    errors.postal_code = FIELD_REQUIRED_ERROR
  }
  if (!phone) {
    errors.phone = FIELD_REQUIRED_ERROR
  }
  if (email && (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email.trim()))) {
    errors.email = 'The value is not a valid email address'
  }
  return errors
}

class PublicProfileForm extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      uploading: false
    }
  }
  render () {
    let {handleSubmit} = this.props
    return (
      <form onSubmit={handleSubmit}>
        <fieldset>
          <div className='row'>
            <div className='col-lg-3 col-md-12 col-sm-6'>
              <Field
                name='gravatar'
                component={UploadImage}
                defaultImage={gravatarDefault}
                imageContainerClassName={styles['upload-image-content']}
                className={styles['upload-image']}
                beforeUpload={() => { this.setState({uploading: true}) }}
                afterUpload={() => { this.setState({uploading: false}) }}
              />
            </div>
            <div className='col-lg-9 col-md-12 col-sm-6'>
              <div className='row'>
                <div className='col-lg-12'>
                  <div className='form-group'>
                    <Field
                      component={SettingField}
                      className='form-control'
                      name='name'
                      maxLength='40'
                      placeholder='Business Name'
                      type='text'
                    />
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-lg-12'>
                  <div className='form-group'>
                    <label className='sr-only'>
                      Description
                    </label>
                    <Field
                      component='textarea'
                      className='form-control general-textarea business-description'
                      name='description'
                      placeholder='Description'
                      rows='10'
                      cols='40'
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-12'>
              <div className='form-group'>
                <label className='sr-only'>
                  Address
                </label>
                <Field
                  component={SettingField}
                  className='form-control'
                  placeholder='Address'
                  maxLength='70'
                  name='address'
                  type='text'
                />
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <div className='form-group'>
                <label className='sr-only'>
                  City
                </label>
                <Field
                  component={SettingField}
                  className='form-control'
                  name='city'
                  maxLength='30'
                  placeholder='City'
                  type='text'
                />
              </div>
            </div>
            <div className='col-md-4'>
              <div className='form-group'>
                <label className='sr-only'>
                  Province
                </label>
                <Field
                  component={SettingField}
                  className='form-control'
                  placeholder='State'
                  maxLength='30'
                  name='province'
                  type='text'
                />
              </div>
            </div>
            <div className='col-md-4'>
              <div className='form-group'>
                <label className='sr-only'>
                  Zipcode
                </label>
                <Field
                  component={SettingField}
                  className='form-control'
                  pattern='[0-9]{5}'
                  name='postal_code'
                  maxLength='5'
                  placeholder='Zip'
                  autoCorrect='off'
                  type='tel'
                  autoCapitalize='off'
                  spellCheck='false'
                  positiveNumberOnly
                  maxFractionDigits={0}
                  keyboardType='numeric'
                />
              </div>
            </div>
          </div>
          <div className='row mb-20px'>
            <div className='col-md-6'>
              <div className='form-group'>
                <label className='sr-only'>
                  Phone
                </label>
                <Field
                  component={PhoneNumberField}
                  name='phone'
                  type='tel'
                  placeholder='812'
                />
              </div>
            </div>
            <div className='col-md-6'>
              <div className='form-group'>
                <label className='sr-only'>
                  Email
                </label>
                <Field
                  component={SettingField}
                  className='form-control'
                  placeholder='Email'
                  maxLength='30'
                  name='email'
                  type='email'
                />
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-12'>
              <div className={styles['mk-sub-section-header']}>
                Links
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-12'>
              <div className={styles['link-list']}>
                <ul>
                  <li>
                    <span className={'fa-stack ' + styles['color-link']}>
                      <i className='fa fa-circle fa-stack-2x' />
                      <i className='fa fa-globe fa-stack-1x fa-inverse' />
                    </span>
                    <div className='form-group'>
                      <label className='sr-only'>
                        Website
                      </label>
                      <Field
                        component='input'
                        className='form-control'
                        placeholder='Website'
                        maxLength='50'
                        name='website'
                        type='text'
                      />
                    </div>
                  </li>
                  <li>
                    <span className={'fa-stack ' + styles['color-twitter']}>
                      <i className='fa fa-circle fa-stack-2x' />
                      <i className='fa fa-twitter fa-stack-1x fa-inverse' />
                    </span>
                    <div className='form-group'>
                      <label className='sr-only'>
                        Twitter
                      </label>
                      <Field
                        component='input'
                        className='form-control'
                        placeholder='Twitter Username'
                        name='twitter'
                        maxLength='50'
                        type='text'
                      />
                    </div>
                  </li>
                  <li>
                    <span className={'fa-stack ' + styles['color-facebook']}>
                      <i className='fa fa-circle fa-stack-2x' />
                      <i className='fa fa-facebook fa-stack-1x fa-inverse' />
                    </span>
                    <div className='form-group'>
                      <label className='sr-only'>
                        Facebook
                      </label>
                      <Field
                        component='input'
                        className='form-control'
                        placeholder='Facebook Username'
                        name='facebook'
                        maxLength='50'
                        type='text'
                      />
                    </div>
                  </li>
                  <li>
                    <span className={'fa-stack ' + styles['color-instagram']}>
                      <i className='fa fa-circle fa-stack-2x' />
                      <i className='fa fa-instagram fa-stack-1x fa-inverse' />
                    </span>
                    <div className='form-group'>
                      <label className='sr-only'>
                        Instagram
                      </label>
                      <Field
                        component='input'
                        className='form-control'
                        placeholder='Instagram Username'
                        name='instagram'
                        maxLength='50'
                        type='text'
                      />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-12'>
              <div className={styles['mk-divider-section-line']} />
            </div>
          </div>
          <div className='row'>
            <div className={'col-lg-12 ' + styles['save-button']}>
              <button
                className='btn btn-primary pull-right'
                id='save-public-profile'
                type='submit'
                disabled={this.state.uploading}
              >
                Save
              </button>
            </div>
          </div>
        </fieldset>
      </form>
    )
  }
}

PublicProfileForm.propTypes = {
  onSubmit: React.PropTypes.func
}

export default reduxForm({
  form: 'publicProfileForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate
})(PublicProfileForm)



// WEBPACK FOOTER //
// ./app/pages/AccountSetting/PublicProfile/PublicProfileForm.js